import React from 'react';
import { Tooltip, Typography } from '@material-ui/core';
import dayjs from 'dayjs';

import { formatDate } from 'utils/functions';

interface Props {
  time: string;
}

const CreatedAt = ({ time }: Props) => {
  const relativeDate = dayjs(time).fromNow() || '';
  const formattedDate = formatDate(`${time}`, 'MMMM D, YYYY h:mm:ss A');

  return (
    <Tooltip title={formattedDate} arrow={true} placement={'bottom'}>
      <Typography variant="caption">{relativeDate}</Typography>
    </Tooltip>
  );
};

export default CreatedAt;
